export default __webpack_public_path__ + "b1289fe85e235ab1dd7bc9e3de222ce9.png";